<!-- Header Area -->
<header class="header-area">
  <div class="navbar-area">
    <div class="floza-responsive-nav">
      <div class="container">
        <div class="floza-responsive-menu">
          <div class="logo">
            <a routerLink="/"
              ><img
                src="assets/img/logo.jpg"
                alt="logo"
                class="header-logo-mobile"
            /></a>
          </div>
        </div>
      </div>
    </div>

    <div class="floza-nav">
      <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
          <a class="navbar-brand" routerLink="/"
            ><img src="assets/img/logo.jpg" alt="logo" class="header-logo"
          /></a>

          <div class="collapse navbar-collapse mean-menu">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <a
                  routerLink="/"
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{
                    exact: true
                  }"
                  >Home</a
                >
              </li>

              <li class="nav-item">
                <a
                  routerLink="/services"
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{
                    exact: true
                  }"
                  >Services
                </a>
              </li>

              <li class="nav-item">
                <a
                  routerLink="/contact"
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  >Contact Us</a
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</header>
<!-- End Header Area -->
